import { createSelector } from 'reselect';

import { GlobalState } from '../../reducers';

const settingsSelector = (state: GlobalState) => state.apps.appManagement.settings;

const isSettingsLoadingSelector = createSelector([
  settingsSelector,
],
(settingsState) => settingsState.isLoading,
);

export default {
  isSettingsLoadingSelector,
};
